import React from "react";
import { 
  Dialog, 
  DialogContent, 
  IconButton, 
  Box,
  useTheme,
  useMediaQuery
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { MapRainforestMarker } from "types/map";
import MapMarkerRainforestInfo from "./MapMarkerRainforestInfo";

type Props = {
  open: boolean;
  onClose: () => void;
  marker: MapRainforestMarker;
  squareFootage?: number;
};

const MapMarkerRainforestDialog = ({ open, onClose, marker, squareFootage }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 3,
          position: 'relative'
        }
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 1 }}>
          <MapMarkerRainforestInfo marker={marker} squareFootage={squareFootage} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MapMarkerRainforestDialog;
